import FileSaver from "file-saver";

/**
 * 通用方法utils
 * @namespace utils
 */
const utils = {
    /**
     * 站内页面跳转，使用hash路由
     * 注意，当前项目转为探索使用browserRouter，跳转请使用useNavigate
     * @param {String} path 目标页面路径，例："#/WebServer"
     */
    routeToPage: function(path){
        window.location.href = path;
    },

    /**
     * 获取当前是开发/测试/正式环境的方法
     */
    getEnv: function() {
        let origin = window.location.origin;
        if (origin.indexOf("localhost") > -1) {
            return "dev"
        } else if (origin.indexOf("test") > -1) {
            return "test"
        } else {
            return "product"
        }
    },

    /**
     * 模拟点击链接的方法打开新页面
     * @param {*} url 
     */
    open: function(url) {
        let a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        a.remove();
    },

    /**
     * 查找目标字符串是否在某个字符串数组中
     * @param {String[]} arr 
     * @param {String} target 
     */
    contain: function(arr,target){
        if(!arr){
            return false;
        }

        return arr.indexOf(target) > -1;
    },

    /**
     * 检查传入的array数组，返回其中不在values数组中的所有值组成的新数组
     * @param {Array} array 
     * @param {Array} values 
     */
    diffArray: function(array, values){
        return utils.uniqueArray(array).filter((value) => !utils.contain(values, value))
    },

    /**
     * 获取两个数组的交集
     * @param {Array} arr1 
     * @param {Array} arr2 
     */
    intersect: function(arr1, arr2) {
        let intersection = arr1.filter(item => arr2.includes(item));
        return intersection;
    },

    /**
     * 判断两个对象所有值是否相等，方法网上抄的
     * @param {Object} a 
     * @param {Object} b 
     * @returns 
     */
    isObjectValueEqual: function(a, b) {
        // 判断两个对象是否指向同一内存，指向同一内存返回 true
        if (a === b) return true ;
        
        // 获取两个对象键值数组
        let aProps = Object.getOwnPropertyNames(a);
        let bProps = Object.getOwnPropertyNames(b);
        // 判断两个对象键值数组长度是否一致，不一致返回 false
        if (aProps.length !== bProps.length) return false ;
        // 遍历对象的键值
        for (let prop in a) {
            // 判断 a 的键值，在 b 中是否存在，不存在，返回 false
            if (b.hasOwnProperty(prop)) {
            // 判断 a 的键值是否为对象，是则递归，不是对象直接判断键值是否相等，不相等返回 false
                if (typeof a[prop] === 'object' && a[prop] !== null) { // 注意这里有大坑，typeof(null) === 'object'，要进行排除；js，很神奇吧（呕
                    if (!utils.isObjectValueEqual(a[prop], b[prop])) return false;
                } else if (a[prop] !== b[prop]) {
                    return false;
                }
            } else {
                return false;
            }
        }
        return true;
    },

    /**
     * 判断某个指定对象是否在数组中
     * @param {Array} arr 
     * @param {*} targetObj 
     */
    objContain: function(arr, targetObj) {
        if (!arr) {
            return false;
        }
        let result = false;
        arr.forEach((item, index) => {
            if (utils.isObjectValueEqual(item, targetObj)) {
                result = true;
            }
        })
        return result;
    },

    /**
     * 从目标数组中移除指定对象，返回一个删除后的数组
     * @param {Array} arr 
     * @param {*} target 
     */
    removeObjFromArray: function (arr, target) {
        let result = [];
        arr.forEach((item, index) => {
            if (!utils.isObjectValueEqual(item, target)) {
                result.push(item);
            }
        })
        return result;
    },

    /**
     * 为指定数组的每一项加上"key"字段，用于处理传给table的data数组
     * @param {Object[]} arr 要加上key字段的数组
     * @return 加上key字段后的原数组的复制
     */
    addKeyForArray: function(arr){
        if(!arr){
            return [];
        }
        let _arr = [];
        arr.forEach((item, index) => {
            item.key = index;
            _arr.push(item);
        });
        return _arr;
    },

    /**
     * 判断当前页面是否位于home页，用于区别处理home页的样式
     */
    isHome: function(){
        return window.location.hash === '#/Home';
    },

    /**
     * 在browseRouter下判断当前是否处于首页
     */
    isHomeBrowseRouter: function() {
        return window.location.pathname === "/";
    },

    /**
     * 将指定文字生成指定文件名的文件并下载
     * @param {String} text 用于生成文件的文本内容
     * @param {String} fileName 生成的文件名，如"test.fasta"
     */
    downloadText: function(text, fileName){
        let blob = new Blob([text], {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob, fileName);
    },

    /**
     * 将指定的数据list合成为csv输出用字符串
     * @param {String[]} title 
     * @param {Array} data 
     */
    dataToCSVString: function(title, data){
        let resultList = [];
        resultList.push(title.map((value, index) => {return "\"" + value + "\""}).join(",")); // 先将title行用逗号连接起来，注意先用双引号将内容包裹
        data.forEach((value, index) => {
            resultList.push(Object.values(value).map((v, i) => {return "\"" + v + "\""}).join(","));
        });
        return resultList.join("\n");
    },

    /**
     * 重定向页面至Http
     */
    redirectToHttp: function(){
        let currentProtocol = window.location.protocol;
        let currentHref = window.location.href;
        if(currentProtocol === 'https:'){
            let newHref = currentHref.replace('https://', 'http://');
            window.location.href = newHref;
        }
    },
    /**
     * 给数字加上千位分割符
     * @param {} num 
     */
    toThousands: function(num) {
        num = (num || 0).toString();
        let result = '';
        while (num.length > 3) {
            result = ',' + num.slice(-3) + result;
            num = num.slice(0, num.length - 3);
        }
        if (num) {
            result = num + result;
        }
        return result;
    },
    /**
     * 滚动到指定id的Dom元素
     * @param {String} id 需要滚动到的元素的Id
     */
    scrollToElementById: function (id) {
        let targetDom = document.getElementById(id);
        if(targetDom){
            targetDom.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });
        }
    },
    /**
     * 将输入的数字转化为1st,2nd,3rd,4th...，注意目前4以后的全部加后缀th，以后有必要再修正
     * @param {Number} num 要转换为序号的数字
     */
    toOrderNumber: function (num) {
        if(!num || num < 0){
            return 'Out of range';
        }

        const orderMap = {
            1: "1st",
            2: "2nd",
            3: "3rd"
        };

        if (num < 4) {
            return orderMap[num];
        } else {
            return num + "th";
        }
    },
    /**
     * 将传入的数组（元素为对象）根据某个属性值进行顺序排列的方法，注意会直接改变原数组，同时本方法返回数组的引用
     * @param {Array} array 
     * @param {String} property 
     * @param {Boolean} reverse 传入该参数为true，则代表倒序排列
     */
    sortArrayByProp: function (array, property, reverse) {

        function compare (property) {
            return function(a, b){
                if (reverse) {
                    return b[property] - a[property]
                } else {
                    return a[property] - b[property]
                }
            }
        }

        array.sort(compare(property));
        return array;
    },
    /**
     * 将时间戳转换为本地时间字符串
     * @param {Number} timestamp 
     * @param {String} format 自定义格式
     */
    timestampToLocalTime: function (timestamp, format) {

        let date = new Date(parseInt(timestamp));

        return this.dateFormat(format || 'YYYY-mm-dd HH:MM:SS', date);
    },
    /**
     * 日期格式化
     * @param {String} fmt 
     * @param {Date} date 
     * @returns 
     */
    dateFormat: function (fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    },
    /**
     * 输入文件大小，返回计算表示文件大小多少MB的字符串
     * @param {Number} fileSize 
     * @returns 
     */
    renderFileSizeMB: function (fileSize) {
        return ((fileSize/1024/1024).toFixed(2) + " MB");
    },
    /**
     * 输入文件大小，返回计算表示文件大小多少KB的字符串
     * @param {Number} fileSize 
     * @returns 
     */
     renderFileSizeKB: function (fileSize) {
        return ((fileSize/1024).toFixed(2) + " KB");
    },
    /**
     * 判断对象是否是一个数字
     * @param {Obj} obj 
     * @returns 
     */
    isNumber: function (obj) {
        return typeof obj === 'number' && !isNaN(obj);
    },
    /**
     * 数组去重，注意这是最简单的去重法，无法去除重复空对象
     * @param {Array} arr 
     * @returns 
     */
    uniqueArray: function (arr) {
        return Array.from(new Set(arr));
    },
    /**
     * 这个方法用于构建{label: a, value: a}这样子的形式用于作为antd的options使用
     * @param {Array} array 单纯的数组 
     */
    getOptionsFromArray: function (array) {
        let result = [];
        array.forEach((value) => {
            let option = {
                label: value,
                value: value
            };
            result.push(option)
        })
        return result;
    },
    /**
     * 该方法用于从一系列相同对象填充的数组中，根据特定字段名提取对应的值，并返回这些值填充的数组
     * @param {Array} array 
     * @param {String} key 
     */
    extractValueFromObjectArrayByKey: function (array, key) {
        let result = [];
        array.forEach((item, index) => {
            result.push(item[key])
        });
        return result;
    },
    /**
     * 该方法用于从一系列相同对象填充的数组中，根据特定字段名提取对应的值，并返回这些值填充的数组，注意这个版本的方法中输入的键名支持多层调用
     * @param {Array} array 
     * @param {Array} keys
     */
     extractValueFromObjectArrayByKeyArray: function (array, keys) {
        let result = [];
        array.forEach((item, index) => {
            let target = item;
            for (let i = 0;i<keys.length;i++) {
                target = target[keys[i]];
            }
            result.push(target);
        });
        return result;
    },
    /**
     * 遍历对象列表，并依据规定字段的值是否在值列表中进行筛选，返回筛选后的对象列表
     * @param {Array} array 
     * @param {String} key 
     * @param {Array} values 
     * @returns 
     */
    filterArrayByKey: function (array, key, values) {
        let result = [];
        array.forEach((item, index) => {
            if (utils.contain(values, item[key])) {
                result.push(item);
            }
        })
        return result;
    },
    /**
     * 利用递归进行对象深拷贝，注意无法拷贝循环引用的对象
     * @param {Object} obj 需要拷贝的原对象
     * @returns 
     */
    deepCopy: function (obj) {
        let newObj = null;
        if(typeof(obj) === 'object' && obj !== null){
            newObj = obj instanceof Array ? [] : {};
            for (let i in obj) {
                newObj[i] = utils.deepCopy(obj[i])
            }
        } else {
            newObj = obj;
        }
        return newObj;
    },
    /**
     * 将只有数值的数组，组装为对象数组，用于满足ui库一些地方的需要，每个对象的键由第二个数组决定，值则全部相同
     * @param {Array} valueArray 
     * @param {Array} keyArray 
     */
    generateObjList: function (valueArray, keyArray) {
        if (!valueArray) {
            return []
        }
        let result = [];
        valueArray.forEach((value) => {
            let obj = {};
            keyArray.forEach((key) => {
                obj[key] = value;
            })
            result.push(obj);
        })
        // console.log(result)
        return result;
    },
    /**
     * 遍历数组中的对象，返回对应字段和输入值匹配的第一个对象
     * @param {Array} array 
     * @param {String} key 
     * @param {*} value 匹配用的值
     */
    matchByKey: function (array, key, value) {
        let result = "";
        array.forEach((item, index) => {
            // console.log(item, value)
            if (item[key] == value) {
                result = item
            }
        })
        return result;
    },
    /**
     * 将有子节点的树形数据展平，需自定义保留对象中的哪些字段
     * @param {Array} treeData 树形数据列表
     * @param {Array} keyList 所有展平后对象需要的字段列表
     * @param {String} treeNodeName 子节点列表的字段键名
     */
    flatTreeData: function (treeData, keyList, treeNodeName) {
        let result = [];
        treeData.forEach((item, index) => {
            let data = {};
            keyList.forEach((key, index2) => {
                data[key] = item[key]
            })
            result.push(data);
            if (item[treeNodeName]) {
                result = result.concat(utils.flatTreeData(item[treeNodeName], keyList, treeNodeName))
            }
        })
        return result;
    },
    /**
     * 从指定字符串中匹配浮点数，并以数组形式返回匹配的内容
     * @param {String} str 用于匹配的原始字符串 
     */
    matchFloat: function (str) {
        let regExp = /\d+\.\d+/g;
        return str.match(regExp);
    },
    /**
     * 从指定字符串匹配浮点数或整数，注意匹配形如"3."这样的字符时会出问题
     * @param {String} str 
     * @returns 
     */
    matchNum: function (str) {
        let regExp = /\d+(\.)?\d*/g;
        return str.match(regExp);
    },
    /**
     * 将输入的参数对象按键值对转换为url用的search字符串
     * @param {*} paramObj 
     * @returns 
     */
    joinSearchParam: function (paramObj) {
        let result = "?";
        Object.keys(paramObj).forEach((key, index) => {
            if (Array.isArray(paramObj[key])) {
                if (paramObj[key].length > 0) {
                    result += key + "=" + paramObj[key].join(";") + "&";
                }
            } else if (paramObj[key] !== undefined) {
                result += key + "=" + paramObj[key] + "&";
            }
        });
        if (result.endsWith("&")) {
            result = result.slice(0, -1); // 去除末尾多余的&符号
        }
        console.log(result)
        return result;
    },
    /**
     * 将输入的列表按照n个一组划分，返回划分后的新列表
     * input: ['a','b','c','d','e'], 2
     * return: [['a','b'], ['c','d'], ['e']]
     * @param {Array} array 
     * @param {Number} divideBy 
     */
    divideArray: function(array, divideBy) {
        let result = [];
        let item = [];
        for (let i = 0;i < array.length;i++) { // 这里需要保证遍历的顺序
            item.push(array[i]);
            if ((i+1)%divideBy === 0) {
                result.push(item);
                item = [];
            }
        }
        if (item.length > 0) { // 如果最后有没填满的，把它也加入到结果列表的最后
            result.push(item);
        }
        return result;
    },
    /**
     * 按长度生成随机字符串
     * @param {Number} len 需要的随机字符串长度，默认16
     * @returns 
     */
    randomString: function (len) {
        len = len || 16;
        let chars = 'ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'; // 排除了一些容易混淆的字符
        let maxPos = chars.length;
        let result = "";
        for (let i=0;i<len;i++) {
            result += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return result;
    },
    /**
     * 获取一个随机hex颜色
     */
    randomColor: function() {
        return "#" + Math.floor(Math.random() * 16777215).toString(16)
    },
    /**
     * 前端读取一个用户上传的文件
     * @param {File} file 
     * @return {FileReader}
     */
    readFile: function(file) {
        const reader = new FileReader();
        reader.readAsText(file, 'utf8');
        return reader;
    },
    /**
     * 翻转输入对象的键值对，请确保输入对象的值可以作为合法的键
     * @param {*} obj 
     */
    invertKeyValues: function(obj) {
        return Object.keys(obj).reduce((acc, key) => {
            acc[obj[key]] = key;
            return acc;
        }, {})
    },
    /**
     * 传入一个对象数组，根据对象中指定的键的值对这些对象进行分组，对象属于第几组这一信息会被添加到一个新的指定的键中
     * @param {Array} arr 
     * @param {String} key 
     * @param {String} indexKeyName 
     */
    divideGroupByKey: function(arr, key, indexKeyName) {
        let groupValueList = utils.uniqueArray(utils.extractValueFromObjectArrayByKey(arr, key));
        let valueIndexMap = utils.invertKeyValues(Object.assign({}, groupValueList));
        return arr.map((obj, index) => {
            obj[indexKeyName] = valueIndexMap[obj[key]];
            return obj;
        });
    },
    /**
     * 根据多个键的值，对数组中的对象进行分组，分组结果会存在一个数组中返回，结果数组中每个对象包括分组值的列表，以及对象列表
     * @param {*} arr 
     * @param {*} keys 
     */
    divideGroupByMultiKey: function(arr, keys) {
        // 初始时，所有对象置于一个组内
        let result = [
            {
                values: [],
                objList: [...arr]
            }
        ];
        // 遍历所有key值，每个key应用于每个组进行一次分类
        keys.map((key, index) => {
            // 对于单个key值，应用于所有组进行分类
            let _result = [];
            result.map((group, index2) => {
                // 提取该组的指定key的值，每个值会衍生出一个新的组
                let groupValueList = utils.uniqueArray(utils.extractValueFromObjectArrayByKey(group.objList, key));
                groupValueList.map((value, index3) => {
                    let newGroup = {
                        values: [],
                        objList: []
                    };
                    newGroup.values = [...group.values, value]; // 先把值记录在新组的值列表里
                    // 然后遍历组内对象，找出与指定键值相同的对象
                    group.objList.map((obj, index4) => {
                        if (obj[key] === value) {
                            newGroup.objList.push(obj)
                        }
                    });
                    _result.push(newGroup);
                });
            });
            result = _result; // 每个key分组结束后，替换原组
        });

        return result;
    },
    /**
     * 判断一个数组中的内容是否存在重复，注意数组内容需要可以作为键名
     * @param {*} arr 
     */
    isRepeat: function(arr) {
        let hash = {};
        for (let i in arr) {
            if (hash[arr[i]]) {
                return true;
            } else {
                hash[arr[i]] = true;
            }
        }
        return false;
    },
    /**
     * 统计一个原始值数组中所有值的出现次数，返回键值对形式的统计结果
     * @param {*} arr 
     * @returns 
     */
    countArr: function(arr) {
        let hash = {};
        arr.forEach((item, index) => {
            if (!hash[item]) {
                hash[item] = 1;
            } else {
                hash[item]++;
            }
        });
        return hash;
    },
    /**
     * 统计某个值在数组中出现的次数
     * @param {*} arr 
     * @param {*} value 
     * @returns 
     */
    countValueInArr: function(arr, value) {
        let countMap = utils.countArr(arr);
        return countMap[value] || 0;
    },
    /**
     * 已知两个整数，生成他们之间所有整数的数组
     * @param {*} start 
     * @param {*} end 
     */
    generateArray: function(start, end) {
        return Array.from(new Array(end + 1).keys()).slice(start);
    },
    /**
     * 将字符串切割为指定长度返回，如果字符串长度过长，则还会将过长部分替换为省略号
     * @param {String} str 
     * @param {Number} length 
     */
    cutString: function(str, length) {
        if (str.length <= length) {
            return str;
        } else {
            return str.substring(0, length) + "..."
        }
    },
    /**
     * 将字符串处理为正则表达式的方法，注意这里所指的是“写成正则格式的字符串”，需要按字面意思直接转为正则表达式
     * @param {String} str 
     */
    stringToRegExp: function (str) {
        return new RegExp(str.replace("\\", "\\\\")); // 经过论证，大概只需要将单斜杠转换为双斜杠即可保持原意
    },
    /**
     * 将指定内容复制到剪贴板
     * @param {*} str 
     */
    copyText: function (str, cbFun) {
        navigator.clipboard.writeText(str).then(res => {
            cbFun && cbFun()
        }).catch(reason => {
            console.log(reason);
        })
    }
};

export default utils;